import styled from "styled-components";

export const LayerListContainer = styled.div`
  position: relative;
  &:before,
  &:after {
    display: ${({ show }) => (show ? "block" : "none")};
    content: "";
    position: absolute;
  }

  &::before {
    left: calc(100% + 2px);
    top: 20px;
    transform: translateY(-50%);
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-right: 7px solid rgba(0, 0, 0, 0.1);
    filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.1));
  }
  &::after {
    left: calc(100% + 2px);
    top: 20px;
    transform: translateY(-50%);
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #ffffff;
    filter: drop-shadow(-2px 0 1px rgba(0, 0, 0, 0.1));
  }

  div:first-child {
    user-select: none;
  }
  /* min-width: 300px; */
`;

export const StyledLayerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #ffffff;
`;

export const StyledSidebarLayerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 5px;
  margin-left: 15px;
  position: relative;

  :before {
    content: "";
    position: absolute;
    left: -1px;
    top: 0px;
    width: 1px;
    /* height: calc(100% - 14px); */
    background-color: rgb(209 209 209);
    height: 100%;
  }
`;

export const StyledMenu = styled.div`
  opacity: ${({ show }) => (show ? 1 : 0)};
  pointer-events: ${({ show }) => (show ? "inherit" : "none")};
  width: 250px;
  max-height: 374px;
  z-index: 2;
  position: absolute;
  overflow: auto;
  top: 0px;
  left: calc(100% + 8px);
  padding: 8px 4px;
  background: #ffffff; //#f8f8f8;
  border-radius: 8px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledMenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSidebarMenuContainer = styled.div`
  display: flex;
  height: 28px;
  align-items: center;
  padding: 0px 4px;
  border-radius: 6px;
  margin-left: 0px;
  gap: 4px;
  border-radius: 6px;
  position: relative;

  :before {
    content: "";
    position: absolute;
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 1px;
    background-color: rgb(209 209 209);
    display: none;
  }

  span {
    font-size: 12px;
    color: rgb(73, 73, 73);
    line-height: 20px;
    white-space: nowrap; /* Prevent text from wrapping to the next line */
    overflow: hidden; /* Hide the overflowing text */
    text-overflow: ellipsis; /* Add ellipsis (...) to indicate overflow */
  }
  cursor: default;

  .layer-icons {
    display: none !important;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  :hover {
    background-color: #f4f4f4;

    .layer-icons {
      display: flex !important;
    }
  }
`;

export const StyledMenuItem = styled.div`
  border: 3px solid;
  border-color: ${({ borderColor = "rgb(238, 238, 238)" }) => borderColor};
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px 4px 5px 4px;
  font-size: 14px;
  /* min-height: 35px; */
  /* cursor: pointer; */
  pointer-events: ${({ disabled }) => (disabled ? "none" : "inherit")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  border-radius: 8px;
  transition: all 0.3s;
  display: flex;
  text-align: left;
  gap: 6px;
  background: ${({ bgColor = "#ffffff" }) => bgColor};
  user-select: none;
  border-radius: 100px;
  color: ${({ color }) => color};

  :hover {
    /* border-color: var(--opsColor); */
    /* background: #f3f3f3; */
  }
`;

export const StyledMenuTitle = styled.span`
  flex: 1;
  line-height: normal;
  font-size: 12px;
`;

export const StyledLayerItemButton = styled.div`
  cursor: pointer;
  padding: 4px 2px;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: all 0.3s;

  :hover {
    background: #f3f3f3; //#e3e3e3;
  }
`;

export const StyledMenuItemSection = styled.div`
  display: flex;
  gap: 2px;
`;

export const StyledMenuInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 10px;
  overflow: hidden;
`;

export const StyledLayerLoaderContainer = styled.div`
  position: relative;
  width: 16px;
  height: 28px;
`;
